<template>
    <div class="copyright">
        <i class="fa fa-copyright mr-1"></i>
        <span class="copyright__text"> {{ copyright }}</span>
    </div>
</template>
<script>
export default {
    props: {
        copyright: {
            type: String,
            default: ''
        }
    }
};
</script>
